<template>
    <div class="file-upload-list-wrapper">
        <create-form
            v-bind="$props"
            ref="form"
            :data="localData"
            :field-list="localFieldList"
        />
    </div>
</template>

<script>
import CreateForm from '@weights/CreateForm'

import formDataMixin from '@mixins/createPage/formData'

import { FILE_LABEL, FILE_KEY, FILE_UPLOAD_TYPE } from '@weights/CreateForm/parser/types'

import cloneDeep from 'lodash/cloneDeep'

export default {
    name: 'FileUploadList',
    components: {
        CreateForm
    },
    mixins: [formDataMixin],
    props: {
        field: {
            type: String,
            default: ''
        },
        data: {
            type: Array,
            default: () => []
        },
        fieldList: {
            type: Array,
            default() {
                return []
            }
        },
        value: {
            type: Object,
            default() {
                return {}
            }
        },
        options: {
            type: Object,
            default() {
                return {
                    submitBtn: false,
                    resetBtn: false
                }
            }
        },
        columns: {
            type: Number,
            default: 1
        },
        emits: {
            type: Object,
            default: () => ({})
        },
        childrenField: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            localFieldList: [],
            labelKey: '',
            key: '',
            keyField: {},
            localData: {}
        }
    },
    watch: {
        fieldList: {
            handler(fieldList) {
                // 合并新的文件field
                // this.localFieldList = mergeFieldOfFile(fieldList)
                fieldList.forEach(field => {
                    if (field.componentType === FILE_LABEL) {
                        this.labelKey = field.fieldCode
                    }

                    if (field.componentType === FILE_KEY) {
                        this.key = field.fieldCode
                        this.keyField = field
                    }
                })

                this.formatData()
            },
            immediate: true
        },
        data: {
            handler() {
                this.formatData()
            }
        }
    },
    methods: {
        formatData() {
            const { data, keyField, key, labelKey } = this
            const fieldList = []
            const localData = {}
            data.forEach(item => {
                const field = cloneDeep(keyField)
                field.componentType = item.attributeType || FILE_UPLOAD_TYPE
                // field.defaultValue = item[key] ? JSON.parse(item[key]) : ''
                field.fieldCode = item['attributeCode']
                field.attributeCode = item['attributeCode']
                field.fieldName = item[labelKey]
                field.nullAllowed = !item.required
                field.props = {
                    fileNumber: item.fileNumber
                }
                if (item.fileNumber === -1) { // 合肥需要施工许可证只读，新增规则fileNumber为-1就禁用
                    field.allowEditing = false
                }
                fieldList.push(field)
                localData[item['attributeCode']] = item[key]
            })

            this.localData = localData
            this.localFieldList = fieldList
        },
        getChildFApi() {
            return this.$refs['form']?.fApi
        },
        getFormData() {
            const data = this.$refs['form'].getFormData()
            const res = []
            for (let key in data) {
                res.push({
                    attributeCode: key,
                    attributeValue: data[key]
                })
            }

            return {
                bizConfigVOList: JSON.stringify(res)
            }
        },
        vaildatorForm(cb) {
            this.$refs['form'].vaildatorForm(cb)
        }
    }
}
</script>
